// extracted by mini-css-extract-plugin
export default {"ProviderDocumentsPage":"oFQq2od8"};